import React from "react";
import "./style.css";

const Header = () => {
  return (
    <div className="bounce">
      <h1> DASHBOARD  DASHBOARD DASHBOARD </h1>
    </div>
  );
};

export default Header;
